export default __webpack_public_path__ + "static/media/subM.5780d36e.png";